import React from 'react';
import {Spinner} from 'react-bootstrap';
import styles from './LoadingSpinner.module.scss';

export interface LoadingSpinnerProps {
    size?: 'sm' | undefined;
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                                  size = 'sm',
                                                                  variant = 'primary',
                                                                  text = 'Loading...'
                                                              }) => {
    return (
        <div className={styles.container}>
            <Spinner
                animation="border"
                size={size}
                variant={variant}
                role="status"
                aria-hidden="true"
            />
            {text && <span className={styles.text}>{text}</span>}
        </div>
    );
};
